import TextIconTip from './TextIconTip';
import './style/text-icon-tip.less';

export default TextIconTip;
